import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { ListVendedorModel } from '../../models/listVendedorModel';
import { CatalogoService } from '../../services/catalogo.service';
import { DistribuidorService } from '../../services/distribuidor.service';

@Component({
  selector: 'app-download-file',
  templateUrl: './download-file.component.html',
  styleUrls: ['./download-file.component.css']
})
export class DownloadFileComponent implements OnInit {
  
  titulo = "Descargar Csv"
  formulario: FormGroup;
  cmbVendedor: ListVendedorModel[] = [];
  objSelected: ListVendedorModel;
  loading = false;
  
  constructor(public fb: FormBuilder,
    private _util: UtilsService,
    private _distribuidor: DistribuidorService,
    private catalogo: CatalogoService,
  ) { }

  ngOnInit() {
    this.formulario = this.fb.group({
      vendedor: ['', [Validators.required]],
    });
    this.getVendedores();
  }

  getVendedores() {
    this._distribuidor.getVendedor().subscribe((res:ListVendedorModel[])=>{
        this.cmbVendedor = res;
    },(err) => {
      this.cmbVendedor = [];
      console.log(err);
    });
  }

  obtenerObjetoVendedor(event) {
    // debugger
    this.objSelected = event[0];
    if(this.objSelected != undefined) {
      this.formulario.get('vendedor').setValue(this.objSelected.temno);
    } else {
      this.formulario.get('vendedor').setValue('');
    }
  }

  decargarFile() {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea descargar el siguiente archivo?',
        text: '',
        action: 'Descargar',
        funcion: this._distribuidor.downloadFile(this.objSelected),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this._util.descargarArchivo(res.clave, res.valor);
    }).catch((err) => {
      this._util.mensajeErroToast(err.error.mensaje, 5000);
    });
  }

}
